import { Body1, Stack, Subtitle1 } from '@phx/design-system';
import { IllustrationCard, NoResultsIllustration } from '@phx/myphx-lib';
import { useTranslation } from 'react-i18next';

export const NoProviderOffers = () => {
    const { t } = useTranslation();

    return (
        <IllustrationCard
            illustrationPosition="top"
            Illustration={NoResultsIllustration}
            illustrationSize="lg"
            variant="bare"
        >
            <Stack gap="xs">
                <Subtitle1 ta="center">
                    {t('providerOffers.noResults.title')}
                </Subtitle1>
                <Body1 ta="center">
                    {t('providerOffers.noResults.description')}
                </Body1>
            </Stack>
        </IllustrationCard>
    );
};
